import { useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import { usePage } from '@orionprotocol/common';

 
import { useEnv } from '../hooks';
import { useAppChainId, useWalletChainId, useWalletAddress } from '../api';

import { useIsAnalyticsEnabled } from './useIsAnalyticsEnabled';
import { analyticsService } from './analyticsService';
import { EventData } from './Analytics';

export interface SendAnalytics {
  sendEvent: (eventName: string, eventData?: Partial<EventData>) => void;
}

export function useAnalytics(): SendAnalytics {
  const { env } = useEnv();
  const networkId = useAppChainId();
  const walletId = useWalletChainId();
  const walletAddress = useWalletAddress();
  const page = usePage();
  const isAnalyticsEnabled = useIsAnalyticsEnabled();

  const sendEvent = useCallback(
    (eventName: string, eventData?: Partial<EventData>): void => {
      if (!isAnalyticsEnabled) {
        return;
      }

      const baseData = {
        app: isMobile ? 'mobile' : 'desktop',
        env,
        networkId,
        walletId,
        walletAddress,
        page,
      };

      const data = {
        ...baseData,
        ...eventData,
      };

      analyticsService.sendEvent(eventName, data);
    },
    [isAnalyticsEnabled, env, networkId, walletId, walletAddress, page],
  );

  return {
    sendEvent,
  };
}
